import GlobalFields from 'defs/ga/fields/global';
import { CardActions, CardProps } from 'defs/ga/fields/product';

export const trackCardCompletedAction = ({
	coachProgId,
	coachCardProdId,
	coachCardProdNm,
	coachCardType,
	buttonText,
}: {
	coachProgId: string;
	coachCardProdId: string;
	coachCardProdNm: string;
	coachCardType: string;
	buttonText?: string;
}) => ({
	[GlobalFields.Event]: 'buttonClick',
	[CardActions.ButtonText]: buttonText || 'tick',
	[CardActions.ProductName]: coachCardProdNm,
	[CardActions.ProductId]: coachCardProdId,
	[CardProps.Type]: coachCardType,
	coachProgId,
});

export const trackCardCompletedActionPoints = ({
	coachProgName,
	coachProgAction,
	coachProgStart,
	coachProgEnd,
	coachProgDuration,
	coachLanguage,
	coachLevelStatus,
	coachLevelPoints,
	coachTaskPoints,
}: {
	coachProgName: string;
	coachProgAction: string;
	coachProgStart: string;
	coachProgEnd: string;
	coachProgDuration: string;
	coachLanguage: string;
	coachLevelStatus: string;
	coachLevelPoints: string;
	coachTaskPoints: string;
}): Object => ({
	[GlobalFields.Event]: 'coach_programm',
	[CardActions.Action]: coachProgAction,
	[CardActions.ProgramName]: coachProgName,
	[CardActions.ProgramStart]: coachProgStart,
	[CardActions.ProgramEnd]: coachProgEnd,
	[CardActions.ProgramDuration]: coachProgDuration,
	[CardActions.Language]: coachLanguage,
	[CardActions.LevelStatus]: coachLevelStatus,
	[CardActions.LevelPoints]: coachLevelPoints,
	[CardActions.TaskPoints]: coachTaskPoints,
});
